import signatureQuillConfig, { signatureVariables } from '@/quill/signatureConfig'

// {{ pos.name }} resolves from the CONVERSATION's point of sale (SendMessage,
// StartConversation and TicketConversationService all read it there), so it is
// only ever fillable on a shop that runs points of sale.
const POINT_OF_SALE_VARIABLE = 'pos.name'

/**
 * Quill config for the Textvorlagen editor: the signature toolbar plus the
 * variables that only make sense in a REPLY — who is being written to, and which
 * ticket it is about.
 *
 * A separate config rather than a longer shared list: signatureConfig also drives
 * the mailbox and POS default signatures, where offering {{ ticket.number }}
 * would produce an empty string in every message that has no ticket.
 *
 * The ticket and point-of-sale variables are gated the same way the WhatsApp
 * placeholders are (whatsappPlaceholderOptions): a shop that never booked the
 * ticket system has no ticket on any thread, and one without points of sale has
 * no POS on any conversation, so those pills could only ever render blank.
 *
 * The variable `value` is the placeholder key; App\Services\Communication\SignatureRenderer
 * substitutes the same keys at send time, so this list and that map must agree.
 */
export const messagePresetVariables = ({ hasTickets, hasPointOfSale }) => [
    ...signatureVariables.filter(variable => hasPointOfSale || variable.value !== POINT_OF_SALE_VARIABLE),
    { label: 'Recipient name', value: 'recipient.name' },
    ...(hasTickets
        ? [
            { label: 'Ticket number', value: 'ticket.number' },
            { label: 'Ticket subject', value: 'ticket.subject' }
        ]
        : [])
]

const messagePresetQuillConfig = context => ({
    ...signatureQuillConfig,
    modules: {
        ...signatureQuillConfig.modules,
        placeholder: {
            variables: messagePresetVariables(context),
            placeholder: 'Search variable...'
        }
    }
})

export default messagePresetQuillConfig
